import { excuseApi } from "../commons/http";

class OrderActivity {
  constructor(data = {}) {
    this.id = data.id;
    this.order_id = data.order_id;
    this.activity_type = data.activity_type;
    this.title = data.title;
    this.description = data.description;
    this.metadata = data.metadata;
    this.performed_by = data.performed_by;
    this.performer = data.performer;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  async save() {
    try {
      const res = await excuseApi({
        path: `/orders/${this.order_id}/activities`,
        method: 'POST',
        body: {
          order_id: this.order_id,
          activity_type: this.activity_type,
          title: this.title,
          description: this.description
        }
      });

      if (res.status === 200 || res.status === 201) {
        return { success: true, message: "Thêm hoạt động thành công!", data: res.data.data };
      }
      return { success: false, message: "Không thể thêm hoạt động" };
    } catch (error) {
      throw error;
    }
  }

  static async getByOrderId(orderId) {
    try {
      const res = await excuseApi({
        path: `/orders/${orderId}/activities`,
        method: 'GET'
      });

      if (res.status === 200) {
        return {
          data: res.data.data.map(item => new OrderActivity(item))
        };
      }
      return { data: [] };
    } catch (error) {
      throw error;
    }
  }
}

export default OrderActivity;
